import { render, staticRenderFns } from "./CambiosOriginalAdd.vue?vue&type=template&id=5e56690f&"
import script from "./CambiosOriginalAdd.vue?vue&type=script&lang=js&"
export * from "./CambiosOriginalAdd.vue?vue&type=script&lang=js&"
import style0 from "./CambiosOriginalAdd.vue?vue&type=style&index=0&id=5e56690f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports